export default "__VITE_ASSET__BpSGq$Gx__"